let AutoInvestInterestController = function(AutoInvestPreferences: any, FCAutoInvestInterestData: any) {
    let vm = this;
    vm.autoInvestPreferences = new AutoInvestPreferences(FCAutoInvestInterestData.auto_invest_preferences);
};
angular.module('fundersclub.autoinvest').controller('AutoInvestInterestController', AutoInvestInterestController);
